import { createFileRoute } from "@tanstack/react-router";
import IRSFreshStartProgramGuide from "@/pages/site/IRSFreshStartProgramGuide";

export const Route = createFileRoute("/resources/irs-fresh-start-program-guide")({
  component: () => <IRSFreshStartProgramGuide />,
});
